import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BuildingsTable from "@/components/tables/buildings/BuildingsTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingTableView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BuildingsTable))
}
}

})